module.exports = __webpack_public_path__ + "img/bluesolar_75_15.57ff8444.png";